import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import SiteLayout from "@/components/SiteLayout";
import { CLUSTER_TOPICS } from "@/lib/content";

export default function PreventiviHub() {
  const navigate = useNavigate();
  return (
    <SiteLayout
      seo={{ title: "Preventivi di ristrutturazione", description: "Hub OKKIO sui preventivi di ristrutturazione: casa, bagno, cucina, impianti, pavimenti, tinteggiatura, infissi e fotovoltaico. Analisi indipendente voce per voce.", path: "/preventivi" }}
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Preventivi", to: "/preventivi" }]}
      narrow>
      <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">Preventivi di ristrutturazione</h1>
      <p className="mt-5 text-lg text-slate-600 leading-relaxed">
        Che tu debba rifare il bagno, la cucina o l’intera casa, il principio è lo stesso: un preventivo va capito
        prima di firmarlo. Qui trovi il punto di partenza per ogni tipologia di intervento.
      </p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {CLUSTER_TOPICS.map((c) => (
          <div key={c.slug} className="rounded-2xl border border-slate-200 bg-white p-5 flex items-center justify-between">
            <div>
              <h2 className="font-heading font-semibold text-slate-900">{c.label}</h2>
              <p className="text-xs text-slate-400 mt-0.5">Approfondimento in arrivo</p>
            </div>
            <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">presto</span>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-3xl bg-white border border-slate-200 p-8 text-center">
        <h2 className="font-heading text-2xl font-semibold text-slate-900">Hai già un preventivo?</h2>
        <p className="mt-2 text-slate-600">Non aspettare le guide: analizzalo subito.</p>
        <Button data-testid="hub-cta" onClick={() => navigate("/controlla-preventivo")}
          className="mt-6 rounded-full h-14 px-8 text-base font-semibold bg-[#3157F6] hover:bg-[#2444D8] active:scale-95 transition-transform">
          Controlla il tuo preventivo <ArrowRight className="w-5 h-5 ml-1" />
        </Button>
      </div>
    </SiteLayout>
  );
}
